import script from "./BookmarkButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookmarkButton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__